// {% comment %}
//     AnyGiftアプリ用: カートページでeギフト購入の商品がカートにあれば、配送設定の要素を削除するスクリプト
// {% endcomment %}

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec));

// {% comment %}配送日時指定要素を探索する。非同期的にレンダリングされる場合もあるので、見つかるまでリトライを重ねる{% endcomment %}
const searchShippingDayElement = async () => {
  for (let i = 0; i < 40; i++) {
    const shippingDayElement = document.querySelector('.calendarMaster__autoInstall');
    if (shippingDayElement) {
      return shippingDayElement;
    }
    await sleep(200);
  }
  return null;
};

// let shippingDayElement;
// searchShippingDayElement().then(element => {
//   if (element) {
//     shippingDayElement = element;
//   }
// });


// {% comment %}商品ページからすでにギフト設定がされている場合にも、配送日時設定要素を隠す{% endcomment %}
searchShippingDayElement().then(shippingDayElement => {
  if (shippingDayElement) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const isGiftEnabledItemInCart = cart.items.some(item =>
          item.properties &&
          'ギフト購入' in item.properties &&
          item.properties['ギフト購入'] === '有効'
        );
        if (isGiftEnabledItemInCart) {
          shippingDayElement.style.display = 'none';
        }
      })
      .catch(error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
      });
  }
});






